import _classnames from 'clsx';
import React, { useCallback, useState } from 'react';

/**
 * Component that includes a `trigger` that, when clicked, displays another container with
 * more text or components over top of the `trigger` area.
 */
const PopoverCover = ({ className = '', children, content, selfAligned = true, trigger }) => {
  const [isOpen, setIsOpen] = useState();

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <div
      className={_classnames('PopoverCover__wrapper', {
        'PopoverCover__wrapper--self-aligned': selfAligned,
      })}
    >
      {isOpen ? (
        <div className={_classnames('PopoverCover', className)}>
          {content ? content(close) : children}
        </div>
      ) : null}
      {trigger ? trigger(open) : null}
    </div>
  );
};

export default PopoverCover;
